export const fmt = (v) => (v == null ? "—" : Number(v).toLocaleString("es-DO"));
export const rd = (v) => {
  const x = Number(v || 0);
  if (!x) return "—";
  return x >= 1e6 ? `RD$ ${(x / 1e6).toFixed(1)}M` : `RD$ ${(x / 1e3).toFixed(0)}K`;
};
export const BRAND_COLORS = {
  Chevrolet: "#f4c400", Nissan: "#dc2626", Suzuki: "#3b82f6", Cadillac: "#111827", Infiniti: "#6b7280",
  "Corp JFK": "#0f766e", "Corp STI": "#0f766e", "Salones STI": "#7c3aed", Seminuevos: "#059669",
};
export const brandColor = (n) => BRAND_COLORS[n] || "#64748b";

export const FUNNEL_STEPS = [
  { key: "leads", label: "Clientes potenciales (Leads)", bold: true },
  { key: "descalificado", label: "Descalificado", indent: true },
  { key: "asignados", label: "Asignados", indent: true },
  { key: "oportunidad", label: "Oportunidad", bold: true, stage: "oportunidad" },
  { key: "sometido", label: "Sometido", indent: true, stage: "sometido" },
  { key: "aprobado", label: "Aprobado", indent: true, stage: "aprobado" },
  { key: "firmado", label: "Firmado", indent: true, stage: "firmado" },
  { key: "desestimado", label: "Desestimado", indent: true, stage: "desestimado" },
  { key: "rechazado", label: "Rechazado", indent: true, stage: "rechazado" },
  { key: "en_espera", label: "En espera de respuesta", indent: true, stage: "en_espera" },
  { key: "facturado", label: "Facturado", bold: true },
  { key: "en_proceso", label: "En proceso", bold: true },
];

export function FunnelList({ data, onPick, testid }) {
  return (
    <div className="space-y-0.5" data-testid={testid}>
      {FUNNEL_STEPS.map((s) => {
        const v = data[s.key];
        const click = s.stage && onPick && v > 0;
        return (
          <div key={s.key} className={`flex items-center justify-between text-[13px] py-0.5 ${s.indent ? "pl-5 text-gray-600" : "text-gray-900"}`}
               data-testid={`${testid}-${s.key}`}>
            <span className={s.bold ? "font-extrabold" : "font-semibold"}>{s.label}</span>
            {click ? (
              <button className="font-extrabold tabular-nums underline decoration-dotted underline-offset-2 hover:text-cyan-700"
                      onClick={() => onPick(s.stage)} data-testid={`${testid}-${s.key}-btn`}>{fmt(v)}</button>
            ) : (
              <span className={`tabular-nums ${s.bold ? "font-extrabold" : "font-semibold"}`}>{fmt(v)}</span>
            )}
          </div>
        );
      })}
    </div>
  );
}
